var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "audio-icon",
      style: {
        borderColor: _vm.iconColor,
        backgroundColor: _vm.iconBackgroundColor,
      },
      on: {
        click: function ($event) {
          return _vm.$emit("toggleSound")
        },
      },
    },
    [
      _vm.isAudioOn
        ? _c(
            "svg",
            {
              attrs: {
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M0.602539 14.0342V6.43761H2.40767L7.14613 2V17.9453L2.40767 14.0342H0.602539Z",
                  stroke: _vm.iconColor,
                },
              }),
              _c("path", {
                attrs: {
                  d: "M9.6272 5.9873C11.0357 6.63923 12.0349 8.27922 12.0349 10.1993C12.0349 12.1193 11.0357 13.7593 9.6272 14.4112",
                  stroke: _vm.iconColor,
                },
              }),
              _c("path", {
                attrs: {
                  d: "M11.9597 2.2832C14.566 3.57703 16.3973 6.63332 16.3973 10.1976C16.3973 13.7618 14.566 16.8181 11.9597 18.1119",
                  stroke: _vm.iconColor,
                },
              }),
            ]
          )
        : _c(
            "svg",
            {
              attrs: {
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M0.602539 14.0342V6.43761H2.40767L7.14613 2V17.9453L2.40767 14.0342H0.602539Z",
                  stroke: _vm.iconColor,
                },
              }),
            ]
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }